import styled from "styled-components";
import { theme } from "../theme";

export const StyledSearch = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	justify-self: center;
	position: relative; /* Add position relative for dropdown positioning */
	input {
		border: ${({ isWhite }) => (isWhite ? `1px solid ${theme.color.blue1}` : "0")};
		border-right: none;
		background: ${({ isWhite }) => (isWhite ? theme.color.white : theme.color.background)};
		padding: ${({ isWhite }) => (isWhite ? "0.8rem" : "0.8rem 1rem 0.8rem 1.6rem")};
		border-top-left-radius: 0.3rem;
		border-bottom-left-radius: 0.3rem;
		font-family: ${theme.font.secondary};
		outline: none;
		width: 50rem;
		max-width: 60rem;
		flex-grow: 1;
		margin: 0;
		line-height: 100%;
		font-size: 1.6rem;
		font-weight: 300;
		height: 4.2rem;
		&::-webkit-search-decoration,
		&::-webkit-search-cancel-button,
		&::-webkit-search-results-button,
		&::-webkit-search-results-decoration {
			display: none;
		}

		&::placeholder {
			color: ${theme.color.gray};
			font-family: ${theme.font.secondary};
		}
	}
`;
